/* Self-contained size-chart modal.
   Event-delegated so it survives Dawn re-rendering the variant picker.
   No dependency on Dawn's <modal-dialog> custom element.
   If the modal contains an iframe with data-ct-sizechart-src, its src is
   set on first open (lazy) so the page only loads when needed.
*/
(function () {
  var openModal = null;

  function open(id) {
    var m = document.getElementById(id);
    if (!m) return;

    // Portal the modal to <body> so position:fixed is relative to the
    // viewport (Dawn's product wrappers use transforms/animations, which
    // otherwise trap a fixed modal inside a small box).
    if (m.parentElement !== document.body) {
      document.body.appendChild(m);
    }

    m.hidden = false;
    document.body.style.overflow = 'hidden';
    openModal = m;
    var closeBtn = m.querySelector('.ct-sizechart__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!openModal) return;
    openModal.hidden = true;
    document.body.style.overflow = '';
    openModal = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ct-sizechart-open]');
    if (opener) {
      e.preventDefault();
      open(opener.getAttribute('data-ct-sizechart-open'));
      return;
    }
    if (e.target.closest('[data-ct-sizechart-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openModal) close();
  });
})();
